import React from 'react';
import PropTypes from 'prop-types';
import { annotationType } from 'types';
import MatchedAnnotationItem from './components/MatchedAnnotationItem';

import './style.scss';

const createToggleHandler = (id, toggleAnnotation) => () =>
  toggleAnnotation(id);

const MatchedAnnotationList = ({ matchedAnnotations, toggleAnnotation }) => (
  <ul styleName="list" data-test="annotation-list">
    {matchedAnnotations.map(annotation => (
      <MatchedAnnotationItem
        key={annotation.id}
        annotation={annotation}
        toggleAnnotation={createToggleHandler(annotation.id, toggleAnnotation)}
      />
    ))}
  </ul>
);

MatchedAnnotationList.propTypes = {
  matchedAnnotations: PropTypes.arrayOf(annotationType),
  toggleAnnotation: PropTypes.func,
};

export default MatchedAnnotationList;
